import { TypeRoleGroup, TypeRoleGroupInfo } from './role';

export class Template {
    public Id: number;
    public TemplateName: string;
    public TemplateValue: string;
    public RoleGroups: TypeRoleGroup[];
    public TypeRoleGroups: TypeRoleGroupInfo[];
}
